import * as types from "./actionTypes";

export const getERPUrl_API = (partyId, companyId) => ({
    type: types.GET_ERPURL_LIST,
    payload: { partyId, companyId },
});

export const getERPUrlListSuccess = (data) => ({
    type: types.GET_ERPURL_LIST_SUCCESS,
    payload: data,
});

export const editERPUrlID = (data) => ({
    type: types.EDIT_ERPURL_ID,
    payload: data,
});

export const editERPUrlIDSuccess = (data) => ({
    type: types.EDIT_ERPURL_ID_SUCCESS,
    payload: data,
});

export const saveERPUrlMaster = (data) => ({
    type: types.SAVE_ERPURL_MASTER,
    payload: data,
});

export const saveERPUrlMaster_Success = (data) => ({
    type: types.SAVE_ERPURL_MASTER_SUCCESS,
    payload: data,
});

export const updateERPUrlID = (data) => ({
    type: types.UPDATE_ERPURL_ID,
    payload: data,
});

export const updateERPUrlIDSuccess = (data) => ({
    type: types.UPDATE_ERPURL_ID_SUCCESS,
    payload: data,
});

export const delete_ERPUrl_ID = (data) => ({
    type: types.DELETE_ERPURL_ID,
    payload: data,
});

export const deleteERPUrlSuccess = (data) => ({
    type: types.DELETE_ERPURL_ID_SUCCESS,
    payload: data,
});

// NEW
export const getERPUrlDetailsByMasterId_API = (masterId) => ({
    type: types.GET_ERPURL_DETAILS_BY_MASTER,
    payload: { masterId },
});

export const getERPUrlDetailsByMasterIdSuccess = (data) => ({
    type: types.GET_ERPURL_DETAILS_BY_MASTER_SUCCESS,
    payload: data,
});

// NEW
export const getERPUrlPartyDropdown_API = () => ({
    type: types.GET_ERPURL_PARTY_DROPDOWN,
});

export const getERPUrlPartyDropdownSuccess = (data) => ({
    type: types.GET_ERPURL_PARTY_DROPDOWN_SUCCESS,
    payload: data,
});

export const erpUrlApiError = (error) => ({
    type: types.ERPURL_API_ERROR,
    payload: error,
});